import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {Box} from "@mantine/core";
import {ConfirmSubscriptionForm} from "../forms/ConfirmSubscriptionForm";

export const ConfirmSubscriptionPage = () => {
    return (
        <FormPageLayout
            title='Confirm Subscription'
            pageNavigation={<Box/>}
        >
            <SimplePageContentWrapper>
                <ConfirmSubscriptionForm/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};